


















































import Vue from 'vue'
import { fetchVersionById, updateVersion } from '../services/versions-client'
import { VersionCreateData, VersionShowData } from '../types'
import VersionsForm from '../components/VersionsForm.vue'
import AppBackToListButton from '@morpheus/utils/admin-vue/components/AppBackToListButton.vue'

export default Vue.extend({
  name: 'VersionsEdit',
  components: {
    VersionsForm,
    AppBackToListButton
  },
  props: {
    id: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      isLoading: false,
      version: {
        application: 'Client',
        bundle_name: '',
        platform: '',
        enabled: false,
        version: '',
        min_version: '',
        download_url: '',
        api_base_uri: '',
        patch_notes: ''
      },
      showForm: false
    }
  },
  mounted () {
    this.$store.commit('global/setLoading', true)
    fetchVersionById(this.id)
      .then((version: VersionShowData) => {
        Vue.set(this, 'version', {
          application: version.application,
          bundle_name: version.bundle_name,
          platform: version.platform,
          enabled: version.enabled,
          version: version.version,
          min_version: version.min_version,
          download_url: version.download_url,
          api_base_uri: version.api_base_uri,
          patch_notes: version.patch_notes
        })
      })
      .catch(error => {
        this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
      })
      .finally(() => {
        this.showForm = true
        this.$store.commit('global/setLoading', false)
      })
  },
  methods: {
    onSubmit (version: VersionCreateData) {
      this.isLoading = true
      updateVersion(version, this.id)
        .then(() => {
          this.clear()
          this.$store.commit('global/addNotification', {
            text: 'You successfully edited version!',
            type: 'success'
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clear () {
      this.$validator.reset()
    }
  }
})
